import { z } from "zod/v4";
import { sepaSetupResponseSchema, subscriptionResponseSchema } from "../../schemas/finance";
import { fetchApi, fetchVoid } from "../client/internal";

export const billing = {
	createSEPASetup: (
		clubId: string,
		memberId: string,
		data: {
			email: string;
			name: string;
			success_url: string;
			cancel_url: string;
		},
	) =>
		fetchApi(`/${clubId}/members/${memberId}/mandates`, sepaSetupResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	createSubscription: (clubId: string, memberId: string, data: { fee_id: string }) =>
		fetchApi(`/${clubId}/members/${memberId}/subscriptions`, subscriptionResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	listMemberSubscriptions: (clubId: string, memberId: string) =>
		fetchApi(`/${clubId}/members/${memberId}/subscriptions`, z.array(subscriptionResponseSchema)),
	listClubSubscriptions: (clubId: string) =>
		fetchApi(`/${clubId}/subscriptions`, z.array(subscriptionResponseSchema)),
	cancelSubscription: (clubId: string, subId: string) =>
		fetchVoid(`/${clubId}/subscriptions/${subId}`, { method: "DELETE" }),
};
